import React from 'react'
import { Flex } from 'components/Box'
import { HeaderSignupButton, NavbarSettingOffcanvasLaptop, NavbarSettingOffcanvasMobileDisplay, NavLink, WithdrawTextStyle, WithdrawSettingIcon, WithdrawWrapper } from '../HeaderStyled'
import OffCanvasMobile from '../OffCanvasMobile'
import { WithdrawMobileScreen } from 'views/Withdraw/WithdrawStyled'
import HeaderLanguageMenu from '../HeaderLanguageMenu/HeaderLanguageMenu'
import { ReactComponent as GamesFiLogo } from 'assets/Logo/headerLogo.svg'
import { ReactComponent as PlusIcon } from "assets/Icons/PlusGame.svg";
import { ReactComponent as SettingsIcon } from "assets/Icons/SettingsIcon.svg";
import { Link } from "react-router-dom";
import { setUser } from 'state/user';
import { useAppDispatch } from 'state';
import LogoutModal from './LogoutModal'

const WithdrawHeader: React.FC = () => {
    const dispatch = useAppDispatch();

    return (
        <>
            <NavbarSettingOffcanvasMobileDisplay>
                <OffCanvasMobile />
            </NavbarSettingOffcanvasMobileDisplay>

            <NavbarSettingOffcanvasLaptop>
                <WithdrawMobileScreen>
                    <Flex>
                        <Link to="/home">
                            <GamesFiLogo />
                        </Link>
                    </Flex>

                    <Flex>
                        <PlusIcon />
                        <WithdrawTextStyle to="/">Games</WithdrawTextStyle>
                        <HeaderLanguageMenu />
                    </Flex>

                    <WithdrawWrapper>
                        {/* <NavLink to="/cashout">
                            <HeaderSignupButton>Cashout</HeaderSignupButton>
                        </NavLink> */}

                        {/* <NavLink to="/logout">
                            <HeaderSignupButton>Logout</HeaderSignupButton>
                        </NavLink> */}

                        <LogoutModal />

                        {/* <NavLink to="/">
                            <WithdrawSettingIcon>
                                <SettingsIcon />
                            </WithdrawSettingIcon>
                        </NavLink> */}
                    </WithdrawWrapper>

                </WithdrawMobileScreen>
            </NavbarSettingOffcanvasLaptop>
        </>
    )
}

export default WithdrawHeader;